import RewardsClient from '@/api/RewardsClient';
import featureFlagSlugs from '@/constants/featureFlagSlugs';
import { dealershipTypes } from '@/constants/dealershipTypes';

export default {
  state: {
    isRewardsProgramEligible: false,
  },
  actions: {
    async checkEligibilityToRewardsProgram({
      dispatch,
      rootState,
      commit,
    }) {
      const ffLoyaltyEnabled = await dispatch('getFlag', featureFlagSlugs.enableAcvLoyaltyProduct, { root: true });
      const dealerType = rootState.authorization.user.defaultDealer.dealership.dealership_type;
      let hasEligibleDealerType = false;
      if ([dealershipTypes.independent, dealershipTypes.acvCertifiedIndependent]
        .includes(dealerType)) {
        hasEligibleDealerType = true;
      }
      const isSingleDealer = !rootState.authorization.user.hasMultipleDealerships;

      const isLoyaltyProgramEnabled = ffLoyaltyEnabled && hasEligibleDealerType && isSingleDealer;

      if (isLoyaltyProgramEnabled) {
        const api = new RewardsClient();
        const defaultDealerId = rootState.authorization.user.defaultDealer.dealership.id;
        if (defaultDealerId) {
          const eligiblity = await api.isRewardsProgramEligible(defaultDealerId);
          commit('setIsRewardsProgramEligible', eligiblity);
        }
      } else {
        commit('setIsRewardsProgramEligible', false);
      }
    },
  },
  mutations: {
    setIsRewardsProgramEligible(state, eligibility) {
      state.isRewardsProgramEligible = eligibility;
    },
  },
};
